import { render, staticRenderFns } from "./GpglViewer.vue?vue&type=template&id=6a5dec1a"
import script from "./GpglViewer.vue?vue&type=script&lang=js"
export * from "./GpglViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports